export const goToLink = (url, newTab = true) => {
  window.open(url, newTab ? "_blank" : undefined);
};

export const isShadowDomSupported = () => !!document.head.attachShadow;

export const browserFeatures = {};

browserFeatures.supportsPassive = false;
try {
  const opts = Object.defineProperty({}, 'passive', {
    get() {
      browserFeatures.supportsPassive = true;
      return true;
    }
  });
  window.addEventListener("testPassive", null, opts);
  window.removeEventListener("testPassive", null, opts);
} catch (e) {}
